<template>
    <section id="the-team" class="bg-top pt-md-5 pb-md-5 pt-3 pb-3">
        <div class="container pb-5">
            <h2>Meet the team!</h2>

            <div class="team-members">
                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/gina.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Gina</h6>
                        <span>Chief of Marketing</span>
                    </div>
                </div>

                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/maxim.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Maxim</h6>
                        <span>IT Consultant</span>
                    </div>
                </div>

                <div class="team-member linked">
                    <div>
                        <figure>
                            <img src="../assets/team-members/liz.png" alt="">
                            <span>i</span>
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Liz</h6>
                        <span>CFO</span>
                    </div>
                    <router-link :to="{name: 'lizmann'}" target="blank" class="stretched-link"></router-link>
                </div>

                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/evgeniy.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Evgeniy</h6>
                        <span>VP of Analytics</span>
                    </div>
                </div>

                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/david.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>David</h6>
                        <span>Web Developer</span>
                    </div>
                </div>

                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/tasya.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Tasya</h6>
                        <span>Project Manager</span>
                    </div>
                </div>

                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/sergey.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Sergey</h6>
                        <span>VP of Testing</span>
                    </div>
                </div>

                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/andrew.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Andrew</h6>
                        <span>Tech Lead</span>
                    </div>
                </div>

                <div class="team-member">
                    <div>
                        <figure>
                            <img src="../assets/team-members/ilya.png" alt="">
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Ilya</h6>
                        <span>Designer</span>
                    </div>
                </div>

                <div class="team-member linked">
                    <div>
                        <figure>
                            <img src="../assets/team-members/roman.png" alt="">
                            <span>i</span>
                        </figure>
                    </div>
                    <div class="text-center">
                        <h6>Roman</h6>
                        <span>CEO & Founder</span>
                    </div>
                    <router-link :to="{name: 'romanmeytin'}" target="blank" class="stretched-link"></router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

    library.add(faInfoCircle);

    export default {
        name: 'TheTeam',
    };
</script>

<style lang="scss">
    @import '../scss/variables';

    #the-team {
        .team-members {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -15px;
            justify-content: space-around;
        }
        .team-member {
            @include font-size(16px);
            position: relative;
            margin: 0 1rem 5rem;
            figure {
                background: linear-gradient(225deg, rgba(134, 137, 234, .5), transparent) left bottom;
                background-size: 300px;
                border-radius: 50%;
                display: inline-block;
                padding: 10px;
                position: relative;
                img {
                    border-radius: 50%;
                    position: relative;
                }
            }
            h6 {
                font-weight: bold;
                @include font-size(24px);
                color: $color_4;
            }
            span {
                font-weight: 500;
            }
            &.linked {
                figure {
                    transition: background .5s ease-in-out;
                    span {
                        position: absolute;
                        background: $color_3;
                        color: #fff;
                        top: 16px;
                        right: 16px;
                        width: 25px;
                        height: 25px;
                        display: block;
                        border-radius: 50%;
                        text-align: center;
                        font-style: italic;
                        font-family: "Times New Roman", sans-serif;
                        @include font-size(20px);
                        font-weight: bold;
                        line-height: 25px;
                    }
                }
                &:hover {
                    figure {
                        background-position: top right;
                    }
                }
            }
            @media (max-width: 991px) {
                & {
                    margin: 0 0 3rem;
                }
            }
        }
    }
</style>
